export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img10-ec862d78d7acdec09aff5f2602a7487b.png";